import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import MainHero from '@/components/MainHero';
import ProductsCarousel from './ProductsCarousel';

export default function MainSection() {
    const { t } = useTranslation();

    return (
        <MainHero className="main-hero-aspect">
            <div className="relative z-30 text-white-blue-50 mx-auto text-center ">
                <motion.h1
                    className="font-semibold text-mainsection-text sm:text-[32px] text-[24px] lg:text-[46px] leading-[100%] tracking-[0%]"
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.7 }}
                >
                    {t('productsPage.mainTitle')}
                </motion.h1>

                <motion.p
                    className="mt-8 font-medium text-[18px] leading-[26px] lg:leading-[28px] max-w-3xl mx-auto text-mainsection-description"
                    initial={{ y: -30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.6, duration: 0.7 }}
                >
                    {t('productsPage.mainDesc')}
                </motion.p>

                <motion.div
                    className="flex justify-center pt-[100px] lg:pt-[120px] sm:pt-[80px] products-carousel"
                    initial={{ opacity: 0, y: 60 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1, duration: 0.8 }}
                    dir="ltr"
                >
                    <ProductsCarousel />
                </motion.div>
            </div>
        </MainHero>
    );
}
